import Breadcrumbs from '@components/Breadcrumbs';
import ProductsCarousel from '@components/Carousel/Products';
import LoyaltyProgram from '@components/LoyaltyProgram';
import { RecipeCard } from '@ui';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import BestComment from './components/BestComment';
import ProductPageMainBlock from './components/ProductPageMainBlock';
import ProductPageMedia from './components/ProductPageMedia';
import { forwardRef } from 'react';
import type { ProductPageSettings } from './index.type';
import PPTabs from './components/PPTabs';
import { sortlist } from './component';
import { DigitalProductInfoBlock } from './components/components';
import ProductsMiniCarousel from '@components/Carousel/ProductsMini';
import PromoRecipes from './components/PromoRecipes';
// import PrizotekaBanner2025 from '@routes/Prizoteka2025/PrizotekaBanner2025';

const DesktopProductPage = forwardRef<HTMLDivElement, ProductPageSettings>(
  (
    {
      id,
      isFavorite,
      isConsentModalAgreed,
      productInfo,
      breadCrumbsLastItem,
      breadCrumbs,
      isItemInCart,
      amountInCart,
      productRecipe,
      alsoBought,
      isShowCarouselAlsoBought,
      analogs,
      isAnalogsVertical,
      recommendProducts,
      reviewTotalCount,
      // isDisabledPopup,
      activeTab,
      setSort,
      isProductAvailableForRefund,
      productRecipes,
      commentTotalCount,
      isProductHasAttachmentInComments,
      setActiveTab,
      linkToQuestions,
      _commentsResolver,
      changeSort,
      changeUrlToUpBreadCrumbs,
      scrollToReviews,
      task
    },
    ref
  ) => {
    const images =
      productInfo?.images?.square?.map((src, index) => {
        const thumb =
          productInfo?.images?.small?.[index] ||
          productInfo?.images?.square?.[0] ||
          '';
        return {
          type: 'img' as const,
          src,
          thumb,
          original: productInfo?.images?.original?.[index] || ''
        };
      }) || [];

    const videos =
      productInfo?.videos?.map(video => ({
        type: 'video' as const,
        src: video.url ?? '',
        thumb: video?.thumbnail_url ?? ''
      })) || [];

    return (
      <div className={'main-container '}>
        <Breadcrumbs isDesktop withoutBackBtn array={breadCrumbs} />
        <div className='grid mt-7.5 gap-x-[3.75rem] grid-cols-[63.75rem_20rem] lg:grid-cols-[54.375rem_20rem] lg:gap-x-[3.125rem] md:px-[1.563rem] md:block md:grid-cols-none md:gap-x-0'>
          <div className='w-[63.75rem] min-w-[63.75rem] max-w-[63.75rem] lg:w-[54.375rem] lg:min-w-[54.375rem] lg:max-w-[54.375rem]'>
            <div>
              <div className='grid grid-cols-[450px,510px] lg:grid-cols-[450px,390px] gap-x-[3.75rem] lg:gap-x-[1.85rem] mb-5'>
                <ProductPageMedia
                  badges={productInfo.badges}
                  title={productInfo.title}
                  id={id}
                  is_18plus={productInfo.is_18plus && !isConsentModalAgreed}
                  isFavorite={isFavorite}
                  isShowBell={productInfo.productDiscountNotification}
                  // isDisabledPopup={isDisabledPopup}
                  images={images || []}
                  videos={videos || []}
                  isFreeze={!!productInfo.isFreeze}
                  isExpressPickupAval={!!productInfo.isExpressPickupAval}
                  isExpressDeliveryAval={!!productInfo.isExpressDeliveryAval}
                />
                <ProductPageMainBlock
                  id={id}
                  isProductPageDesktop
                  isBarMenu={!!productInfo?.isMenu}
                  task={task}
                  canBeBought={productInfo.canBeBought}
                  promocodeGiftItems={productInfo.promocodeGiftItems}
                  multiPricePromo={productInfo.multiPricePromo}
                  amountInCart={amountInCart}
                  isDigital={productInfo.isDigital}
                  sizeRangeItem={productInfo.sizeRangeItem}
                  available={productInfo.available}
                  rating={productInfo.averageRating}
                  isExpressDeliveryAval={!!productInfo.isExpressDeliveryAval}
                  reviewTotalCount={reviewTotalCount}
                  analogs={analogs}
                  variants={productInfo.variants}
                  title={productInfo.title}
                  subtitle={productInfo.subtitle}
                  article={productInfo.productArticle}
                  isVesovoi={productInfo.isVesovoi}
                  ifWeighting={productInfo.ifWeighting}
                  scrollToReviews={scrollToReviews}
                  newBadges={productInfo.newBadges}
                  supplier_id={productInfo.supplier_id}
                  salesNumberInfo={productInfo.salesNumberInfo}
                  isExpressPickupAval={!!productInfo?.isExpressPickupAval}
                  deliveryDate={productInfo.deliveryDate}
                  gds_count={productInfo.gds_count}
                  priceObj={productInfo.priceObj}
                  isPreorder={productInfo.isPreorder}
                  isProductNotForSale={productInfo.isProductNotForSale}
                  isMenu={!!productInfo?.isMenu}
                  isProductArchieved={productInfo.isProductArchieved}
                  breadCrumbsLastItem={breadCrumbsLastItem}
                  changeUrlToUpBreadCrumbs={changeUrlToUpBreadCrumbs}
                  bestBeforeDate={productInfo.bestBeforeDate}
                  supplyDate={productInfo.supplyDate}
                  availableQuantity={productInfo.availableQuantity}
                />
              </div>
            </div>

            {isItemInCart && alsoBought.length > 0 && (
              <ProductsMiniCarousel
                className='p-3 bg-[var(--ultra-light-grey)] rounded-xl'
                title={
                  isShowCarouselAlsoBought
                    ? 'С этим товаром покупают'
                    : 'Вам может понравиться'
                }
                products={alsoBought}
              />
            )}
            {!productInfo?.isMenu &&
              !productInfo.available &&
              analogs?.length > 0 && (
                <div className='mt-6'>
                  {isAnalogsVertical ? (
                    <ProductsCarousel
                      title='Похожие товары'
                      products={analogs}
                      slidesToShow1280={4}
                      slidesToShow1440={4}
                    />
                  ) : (
                    <ProductsMiniCarousel
                      title='Похожие товары'
                      products={analogs}
                    />
                  )}
                </div>
              )}

            {!productInfo.isProductNotForSale && (
              <PPTabs
                ref={ref}
                how_to_make={productInfo.how_to_make}
                id={id}
                carbs={productInfo.carbs}
                reference_weight={productInfo.reference_weight}
                proteins={productInfo.proteins}
                fats={productInfo.fats}
                isBarMenu={!!productInfo?.isMenu}
                isDigital={productInfo.isDigital}
                activeTab={activeTab}
                sortlist={sortlist}
                setSort={setSort}
                isProductAvailableForRefund={isProductAvailableForRefund}
                productRecipes={productRecipes}
                averageRating={productInfo?.averageRating}
                reviewTotalCount={reviewTotalCount}
                commentTotalCount={commentTotalCount}
                isProductHasAttachmentInComments={
                  isProductHasAttachmentInComments
                }
                setActiveTab={setActiveTab}
                linkToQuestions={linkToQuestions}
                commentsResolver={_commentsResolver}
                changeSort={changeSort}
                weight_of_goods={productInfo?.weight_of_goods}
                measureItem={productInfo?.measureItem}
                country={productInfo?.country}
                attributes={productInfo?.attributes}
                productPackage={productInfo?.productPackage}
                nutritional_value={productInfo?.nutritional_value}
                energy_value={productInfo?.energy_value}
                ingredients={productInfo?.ingredients}
                storage_conditions={productInfo?.storage_conditions}
                gost={productInfo?.gost}
                documents={productInfo?.documents}
                text={productInfo?.text || ''}
                mostUsefulComment={productInfo?.mostUsefulComment}
                isVesovoi={productInfo?.isVesovoi}
                supplier_id={productInfo?.supplier_id}
                videos={productInfo?.videos}
              />
            )}
          </div>

          <div className='flex flex-col gap-y-6 md:hidden w-[20rem] min-w-[20rem] max-w-[20rem]'>
            <PromoRecipes productId={+id} />
            {productInfo.isDigital && <DigitalProductInfoBlock />}
            {!productInfo.isDigital && (
              <LoyaltyProgram
                fullComponent
                className='p-3 bg-[var(--ultra-light-grey)]'
              />
            )}
            {/* <PrizotekaBanner2025 /> */}
            {productInfo.mostUsefulComment && (
              <BestComment
                rating={productInfo.mostUsefulComment.rating}
                avatar={
                  productInfo.mostUsefulComment?.peopleItem?.attachmentsItem
                    ?.cacheItem?.[0]?.filePath
                }
                fio={productInfo.mostUsefulComment?.peopleItem?.fio}
                date={dayjs(productInfo.mostUsefulComment.date).format(
                  'DD.MM.YYYY'
                )}
                text={productInfo.mostUsefulComment.text}
                photos={productInfo.mostUsefulComment.photos}
                peopleItem={productInfo.mostUsefulComment.peopleItem}
              />
            )}

            {productRecipe && !productInfo.isProductNotForSale && (
              <div>
                <div className='mb-5 text-2xl font-medium'>Приготовьте</div>
                <RecipeCard item={productRecipe} />
              </div>
            )}
          </div>
        </div>

        {[
          isShowCarouselAlsoBought
            ? { items: alsoBought, title: 'C этим товаром покупают' }
            : {},
          { items: recommendProducts, title: 'Рекомендуем попробовать' }
        ].map(item => {
          if (item.items && item.items.length > 0) {
            return (
              <ProductsCarousel
                key={item.title}
                products={item.items}
                title={item.title}
              />
            );
          } else {
            return null;
          }
        })}
      </div>
    );
  }
);
export default observer(DesktopProductPage);
